import { render } from "./PlaybookViewTable.vue?vue&type=template&id=e521469a&scoped=true"
import script from "./PlaybookViewTable.vue?vue&type=script&lang=js"
export * from "./PlaybookViewTable.vue?vue&type=script&lang=js"

import "./PlaybookViewTable.vue?vue&type=style&index=0&id=e521469a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e521469a"]])

export default __exports__